export default function ({ route, query, enablePreview }) {
  if (
    query.preview ||
    route.path === '/preview/activate' ||
    query['sanity-preview-perspective']
  ) {
    enablePreview()
  }
}
